var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.667,
    height: 15,
    viewBox: "88 15.078 11.667 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.833 28.412c0 .916.75 1.666 1.667 1.666h6.667c.916 0 1.666-.75 1.666-1.666v-10h-10v10Zm10.834-12.5H96.75l-.833-.834H91.75l-.833.834H88v1.666h11.667v-1.666Z",
    fill: "#707070",
    fillRule: "evenodd",
    "data-name": "Icon material-delete"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconGray);
export default __webpack_public_path__ + "static/media/DeleteIconGray.e28636eac18e1085cf911eb56ff977fe.svg";
export { ForwardRef as ReactComponent };